import React, { useEffect, useState } from "react";
import Breadcrumbs from "common/Breadcrumbs/Breadcrumbs";
import { routeConstants } from "navigation/routeConstants";
import { Button } from "common/Button/Button";
import { ReactComponent as PlusIcon } from "common/assets/icons/plus.svg";
import FolderItem from "common/FolderItem/FolderItem";
import { useNavigate } from "react-router-dom";
import Modal from "common/Modal/Modal";
import { Input } from "common/Input/Input";
import FileUpload from "common/FileUpload/FileUpload";
import axios from "axios";
import { serviceConfig } from "configs";
import { ReactComponent as LangIcon } from "common/assets/flags/tk.svg";
import { ReactComponent as ThemeIcon } from "common/assets/icons/moon-stars.svg";
import { ReactComponent as NotificationIcon } from "common/assets/icons/bell.svg";
import { ReactComponent as AvatarIcon } from "common/assets/icons/user.svg";
import { P } from "common/P/P";

const breadcrumbItems = [
	{ label: "Faýl arhiwi", path: routeConstants.root.route },
	{ label: "Arhiw" },
];

const ArchievePage: React.FC = (): JSX.Element => {
	const navigate = useNavigate();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [folders, setFolders] = useState<any>([]);
	const [newFolderName, setNewFolderName] = useState("");
	const [newFolderFiles, setNewFolderFiles] = useState([]);
	const [filesData, setFilesData] = useState<any>([]);

	const userString = localStorage.getItem("user");
	const user = userString ? JSON.parse(userString) : null;

	const userId = user ? user?.user._id : ""; // Replace with actual user ID
	const userTypeId = user ? user?.user.userTypeId?._id : null;
	const numericUserTypeId = parseInt(userTypeId);

	const handleFileChange = (e: any) => {
		if (e.target.files) {
			const filesArray = Array.from(e.target.files);
			setFilesData(filesArray);
		}
	};

	useEffect(() => {
		const fetchFolders = async () => {
			try {
				const response = await axios.get(`${serviceConfig.apiUrl}/folders`);
				setFolders(response.data);
			} catch (error) {
				console.error("Error fetching folders:", error);
			}
		};

		fetchFolders();
	}, []);

	const handleCreateFolder = async () => {
		const formData = new FormData();
		formData.append("folderName", newFolderName);
		formData.append("userId", userId);
		filesData.forEach((file: any) => {
			// Encode the filename to handle non-Latin characters
			const encodedFilename = encodeURIComponent(file.name);
			// Append the file with the original file object but with an encoded filename
			formData.append("files", file, encodedFilename);
		});

		try {
			await axios.post(`${serviceConfig.apiUrl}/create-folder`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			closeModal();
			setNewFolderName("");
			window.location.reload();
			setFilesData([]); // Reset files data
			// Optionally, fetch folders again to update the list
		} catch (error) {
			console.error("Error creating folder:", error);
		}
	};

	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);
	const handleDoubleClick = (id: number) => {
		navigate(`${routeConstants.archieve.route}/${id}`); // Navigate to the route with the ID
	};
	return (
		<div className="grid grid-cols-1 gap-4">
			<div className="grid grid-cols-1 gap-4 px-6 py-3 place-items-end">
				{/* <LangIcon />
					<ThemeIcon />
					<div className="relative">
						<NotificationIcon />
						<div className="absolute top-[-5px] right-[-5px] grid px-[0.4rem] py-[0.1rem] rounded-full place-items-center place-content-center bg-redColor">
							<P size="t2" type="semibold" className="text-white">
								4
							</P>
						</div>
					</div> */}
				<div className="grid gap-3 grid-cols-maxTwo place-items-center">
					<div className="p-2 rounded-full bg-grayOne">
						<AvatarIcon />
					</div>
					<div className="grid">
						<P size="t1" type="medium">
							{user ? `${user.user.name.charAt(0)}.${user.user.sirname}` : ""}
						</P>
						<P size="t2" type="regular" className="text-grayTwo">
							{user ? user.user.userTypeId?.positionName : ""}
						</P>
					</div>
				</div>
			</div>
			<div className="grid grid-flow-row auto-rows-max pb-7 gap-6 px-6 min-h-[90vh]">
				<Breadcrumbs items={breadcrumbItems} />
				<div className="grid grid-cols-1 place-items-end">
					<Button
						appearance="main"
						paddingY="py-2"
						className="h-max"
						icon={<PlusIcon className="stroke-white" />}
						onClick={openModal}
					>
						Bukja döretmek
					</Button>
				</div>
				<Modal
					isOpen={isModalOpen}
					onClose={closeModal}
					title="Bukja döretmek"
					width="w-[600px]"
				>
					<div className="grid grid-flow-row grid-cols-1 gap-6 auto-rows-max">
						<Input
							appearance="default"
							type="text"
							name="folder_name"
							withlabel={true}
							label="Bukjanyň ady"
							value={newFolderName}
							onChange={(e) => setNewFolderName(e.target.value)}
						/>
						<FileUpload
							files={filesData}
							onChange={handleFileChange}
							label="Ýüklenilýän faýllar"
						/>

						<Button
							appearance="main"
							className="place-self-end"
							paddingX="px-5"
							paddingY="py-[10px]"
							onClick={handleCreateFolder}
						>
							Döretmek
						</Button>
					</div>
				</Modal>
				<div className="grid gap-6 lg:grid-cols-3 TwoXl:grid-cols-4">
					{folders.map((folder: any, idx: number) => (
						<FolderItem
							key={idx}
							name={folder.folderName}
							quantity={folder.files.length}
							files={folder.files.join(", ")}
							onDoubleClick={() => handleDoubleClick(folder._id)}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

export default ArchievePage;
